import { observer } from 'mobx-react-lite';

import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';
import { SIDEBAR_NAMES } from 'common/activeElements/sidebars/sidebarsNames';
import { useActiveElements } from 'global/ActiveElements/useActiveElements';
import { crewMemberDetailsStore as store } from 'pages/CrewMemberDetails/crewMemberDetailsStore';

import Availability from './Availability';
import Essentials from './Essentials';
import Identification from './Identification';
import LoadingInfo from './LoadingInfo';
import NewActions from './NewActions';
import WorkingInfo from './WorkingInfo';

import styles from './styles.module.css';

const Info = observer(() => {
	const active = useActiveElements();

	const { loading, error, employeeInfo, employmentType, editData } = store;
	const hasPermanentLocation = editData?.permanentHomeBase != null;

	const openEditPanel = () => {
		if (editData) {
			active.setActiveElement(SIDEBAR_NAMES.editInfo, { initialData: { driverInfo: editData } });
		}
	};

	return (
		<div>
			<Identification
				loading={loading}
				error={error}
				employeeInfo={employeeInfo}
				onOpenEditPanel={openEditPanel}
			/>
			<NewActions />
			<div className={styles.wrapper}>
				<LoadingInfo loading={loading} error={error} />
				<Essentials
					employeeInfo={employeeInfo}
					error={error}
					hasPermanentLocation={hasPermanentLocation}
					onOpenSetHomeLocation={(value) =>
						active.setActiveElement(MODAL_NAMES.setHomeLocation, { hasPermanentLocation: value })
					}
					onOpenLocationsLog={() => active.setActiveElement(SIDEBAR_NAMES.locationsLog)}
					onOpenUpdateCrewLocation={() =>
						active.setActiveElement(MODAL_NAMES.updateCrewLocation, {})
					}
				/>
				<Availability
					employeeInfo={employeeInfo}
					onOpenAbsence={() => active.setActiveElement(MODAL_NAMES.absence, { readOnly: false })}
				/>
				<WorkingInfo employeeInfo={employeeInfo} employmentType={employmentType} />
			</div>
		</div>
	);
});

export default Info;
